import enLocale from "element-ui/lib/locale/lang/en";
const en = {
  message: {
    lan: "En",
    errorMessage: {
      ServerException: "Server Error ",
      ClientException: "Client Error",
      NetworkException: "Unknown Network Error",
      CheckNetwork: "Please check your network",
      UnknownError: "Unknown Error ",
      captchaError: "Invalid verification code! Please try again"
    },
    index: "Home",
    course_learning: "Course Learning and Progress",
    course_learn: "Course Learning ",
    viewed_times: "Views",
    course_catalog: "Table of Contents",
    learning_progress: "Learning Progress",
    view_exam_record: "Check mock test record",
    learn_review: "Study review",
    continue_learning: "Continue studying",
    to_learn: "START",
    take_the_mock_test: "Take a mock test",
    replay: "Replay",
    play: "Play",
    pause: "Pause",
    muteMe: "Mute",
    sound: "Audio",
    search_chapter_placeholder: "Please enter chapter title",
    practice_test: "Mock Test",
    exam_record: "Mock Test Record",
    course_name: "Course Title",
    exam_score: "Test Score",
    operation_time: "Operating time",
    view: "Check",
    title_TRUE_OR_FALSE: "True or false question",
    title_SINGLE_CHOICE: "Multiple choice question (single answer)",
    title_SHORT_ANSWER: "Short answer question",
    title_MULTIPLE_CHOICE: "Multiple choice question (multiple answers)",
    correct: "Correct",
    wrong: "Wrong",
    correct_answer: "Your answer is correct",
    wrong_answer: "Your answer is wrong",
    right_key: "Correct Answer",
    submit_test: "Submit test paper",
    next_question: "Next question",
    back: "Back",
    exam_result: "Test result",
    answers_situation: "Answer Situation",
    return_exam_record: "Back to mock test record",
    reTest: "Retake the test",
    back_to_home: "Back to home page",
    all: "All",
    learning: "In progress",
    finished_learning: "Finished the course",
    submit: "Submit",
    logout: "Logout",
    course_list: "Course List",
    prev_section: "Previous section",
    next_section: "Next section",
    start_chapter_learn: "Go to this chapter",
    return_prev_chapter: "Back to the previous chapter",
    return_this_chapter: "Back to this charpter",
    start_next_chapter: "Go to the next charpter",
    to_test: "Go to mock test",
    chapter_start: "Start of this chapter",
    chapter_end: "End of this chapter",
    copyright: "© Government of the Macao Special Administrative Region - Labour Affairs Bureau",
    course_entry: "Start the course",
    start_test: "Start the test ",
    test_tips: "The course progress is less than 80%, please study patiently before taking the test",
    question_tips: "The course progress is less than 80%, please study patiently before taking the evaluation survey",

    tips: "Hints",
    confirm: "Confirm",
    question_already: "Each evaluation survey can only be filled out once",

    exam_excellent: "Congratulations! Your score is excellent",
    exam_pass: "Great! You pass the mock test",
    exam_fail: "Please keep it up! Your score is not ideal",

    submit_success: "Successful submission",
    submit_error: "Unsuccessful submission",

    learning_content: "Learning Contents",

    priority_tips: "It is recommended to study the course in the following order",
    goto_course: "Go to Course",
    current: "(current)",
    no_question: "Failure to get the question",
    public_questionnaires_Invalid: "The evaluation survey has expired or not activated!",

    web_title: "Labour Affairs Bureau eLearning",
    question_public_title: "Labour Affairs Bureau ",
    online_services: "Online Application",
    write_tips: "Please complete this evaluation survey, so that the Labour Affairs Bureau can improve this online learning course, thank you!",
    chapter: "Chapter {0} ",
    section: "Section {0} ",
    question_must_be_completed: "The evaluation survey must be completed before submission",
    captcha_plh: "Please enter verification code",
    noData: "No data",
    question: "Course Evaluation Survey",
    noVoice: "Audio in english is not available.",
    numberToCN: [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59"
    ],
    question_tips_content: "In order to improve the [<b>{0}</b>] eLearning system, we would like to invite you to fill in an online questionnaire to help us improve our service. Thank you very much!",
    question_tips_btn1: "Click here to fill in the questionnaire",
    question_tips_btn2: "You haven’t completed the respective course yet, please fill in the questionnaire upon its conclusion.",
  },
  ...enLocale
};
export default en;